import React from 'react';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

const AdminBreadcrumb = ({ activeTab, menuCategories }) => {
  // Find the current item and its category
  const currentItem = menuCategories
    .flatMap(cat => cat.items || [cat])
    .find(item => item.id === activeTab);
  
  const currentCategory = menuCategories
    .find(cat => cat.items?.some(item => item.id === activeTab));

  if (!currentItem) return null;

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-500 mb-4">
      <HomeIcon className="h-4 w-4" />
      <span>Admin</span>
      
      {currentCategory && currentCategory.id !== 'overview' && (
        <>
          <ChevronRightIcon className="h-4 w-4" />
          <span>{currentCategory.name}</span>
        </>
      )}
      
      <ChevronRightIcon className="h-4 w-4" />
      <span className="text-gray-900 font-medium">{currentItem.name}</span>
    </nav>
  );
};

export default AdminBreadcrumb;